export const numbers4 = [
  { number: 1, id: 1 },
  { number: 1, id: 2 },
  { number: 2, id: 3 },
  { number: 2, id: 4 },
  { number: 3, id: 5 },
  { number: 3, id: 6 },
  { number: 4, id: 7 },
  { number: 4, id: 8 },
  { number: 5, id: 9 },
  { number: 5, id: 10 },
  { number: 6, id: 11 },
  { number: 6, id: 12 },
  { number: 7, id: 13 },
  { number: 7, id: 14 },
  { number: 8, id: 15 },
  { number: 8, id: 16 },
];

export const numbers6 = [
  { number: 1, id: 1 },
  { number: 1, id: 2 },
  { number: 2, id: 3 },
  { number: 2, id: 4 },
  { number: 3, id: 5 },
  { number: 3, id: 6 },
  { number: 4, id: 7 },
  { number: 4, id: 8 },
  { number: 5, id: 9 },
  { number: 5, id: 10 },
  { number: 6, id: 11 },
  { number: 6, id: 12 },
  { number: 7, id: 13 },
  { number: 7, id: 14 },
  { number: 8, id: 15 },
  { number: 8, id: 16 },
  { number: 9, id: 17 },
  { number: 9, id: 18 },
  { number: 10, id: 19 },
  { number: 10, id: 20 },
  { number: 11, id: 21 },
  { number: 11, id: 22 },
  { number: 12, id: 23 },
  { number: 12, id: 24 },
  { number: 13, id: 25 },
  { number: 13, id: 26 },
  { number: 14, id: 27 },
  { number: 14, id: 28 },
  { number: 15, id: 29 },
  { number: 15, id: 30 },
  { number: 16, id: 31 },
  { number: 16, id: 32 },
  { number: 17, id: 33 },
  { number: 17, id: 34 },
  { number: 18, id: 35 },
  { number: 18, id: 36 },
];
